import { FC, useContext } from 'react'
import { ChatContext } from '../context/ChatContext'
import { ModalDialog, ModalDialogBody, ModalDialogButtons, ModalDialogTitle } from '../../common/components/ModalDialog'
import { useTranslation } from 'react-i18next'
import { Button } from '../../common/components/Button'
import styled from '@emotion/styled'
import { useInitChat } from '../hooks/useInitChat'

const Content = styled.div`
  margin: 0.75rem 0 1rem;
`

const Title = styled.span`
  white-space: nowrap;
`

export const ChatManualSupportConfirmation: FC = () => {
  const { t } = useTranslation()
  const { manualSupportConfirmationOpened, setManualSupportConfirmationOpened } = useContext(ChatContext)
  const initChat = useInitChat()

  return (
    <ModalDialog
      opened={manualSupportConfirmationOpened}
      onClose={() => {
        setManualSupportConfirmationOpened(false)
      }}
    >
      <ModalDialogBody>
        <ModalDialogTitle>
          <Title>{t('Completed successfully!')}</Title>
        </ModalDialogTitle>

        <Content>
          {t("As soon as it's your turn, they'll email you a quote or contact you if you have any questions.")}
        </Content>

        <ModalDialogButtons>
          <Button
            big
            primary
            onClick={() => {
              initChat()
            }}
          >
            {t('Ok')}
          </Button>
        </ModalDialogButtons>
      </ModalDialogBody>
    </ModalDialog>
  )
}
